import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Cliente } from "src/app/admihair/api/dto/cliente";
import { ClienteService } from "src/app/admihair/service/cliente.service";
import { UtilStorageService } from "src/app/admihair/service/util-storage.service";
import { Empresa } from "src/app/admihair/api/dto/empresa";
import { ConfirmationService, LazyLoadEvent, SelectItem } from "primeng/api";
import { ErroService } from "src/app/admihair/service/erro.service";
import { Paginador } from "src/app/admihair/api/dto/paginacao/paginador";
import { AdmihairBaseComponent } from "../../../admihair-base.component";

@Component({
  selector: "app-cliente-listar",
  templateUrl: "./cliente-listar.component.html",
  styleUrls: ["./cliente-listar.component.scss"],
})
export class ClienteListarComponent extends AdmihairBaseComponent implements OnInit {
  @ViewChild("filter") filter!: ElementRef;
  clientes: Cliente[] = [];
  loadingTable: boolean = false;
  loadingClientes: boolean = false;
  situacoesStatus: SelectItem[] = [
    { label: "ATIVOS", value: true },
    { label: "INATIVOS", value: false },
  ];
  situacaoSelecionada: boolean = true;

  itensPaginados?: Paginador<Cliente>;
  numeroPagina: number = 0;
  inputBusca?: string = "";
  ordenacao: string = "nome,ASC";
  tamanhoPagina: number = 10;

  constructor(
    private clienteService: ClienteService,
    private confirmationService: ConfirmationService,
    router: Router,
    activatedRoute: ActivatedRoute,
    utilStorageService: UtilStorageService,
    erroService: ErroService
  ) {
    super(erroService, utilStorageService, router, activatedRoute);
  }

  ngOnInit(): void {
    this.verificarPermissoes();
  }

  listarClientes() {
    this.loadingTable = true;
    const empresaSelecionada: Empresa = this.getEmpresa();
    this.clienteService
      .listarClientesPorEmpresaESituacaoETextoBuscaPaginado(
        empresaSelecionada.id,
        this.situacaoSelecionada,
        this.numeroPagina,
        this.tamanhoPagina,
        this.ordenacao,
        this.inputBusca
      )
      .subscribe({
        next: (data: Paginador<Cliente>) => {
          this.itensPaginados = data;
          this.clientes = data.content;
          this.loadingTable = false;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.exibirMensagemErro(err);
        },
      });
  }

  onLazyLoad(event: LazyLoadEvent) {
    if (event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.listarClientes();
  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    const campoDeOrdenacao = sortField ? sortField : "nome";
    const direcaoOrdenacao = sortOrder === -1 ? "DESC" : "ASC";
    this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
  }

  excluirCliente(clienteId: number) {
    this.confirmationService.confirm({
      message: "Tem certeza que seja excluir?",
      header: "Confirmação",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      icon: "pi pi-info-circle",
      accept: () => {
        this.clienteService.excluir(clienteId).subscribe({
          next: () => {
            this.listarClientes();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          },
        });
      },
    });
  }

  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarClientes();
  }

  limpar() {
    this.filter.nativeElement.value = "";
    this.inputBusca = "";
    this.situacaoSelecionada = true;
    this.listarClientes();
  }

  verificarPermissoes() {
    this.permissaoListar = this.verificarPermissao("PERM_LISTAR_CLIENTE");
    this.permissaoInserir = this.verificarPermissao("PERM_INSERIR_CLIENTE");
    this.permissaoEditar = this.verificarPermissao("PERM_EDITAR_CLIENTE");
    this.permissaoExcluir = this.verificarPermissao("PERM_EXCLUIR_CLIENTE");
    this.permissaoDetalhar = this.verificarPermissao("PERM_DETALHAR_CLIENTE");
  }
}
